/**
This file is here so that `sq-calendar-month` doesn't blow up when this helper
isn't present. To localize or otherwise customize this helper, exclude this helper
by using the `excludeFallbackFormatHelpers: true` option.
*/

import { helper as buildHelper } from '@ember/component/helper';
import moment from 'moment';
export default buildHelper(([value]) => {
  return moment(value).format('M/D');
});